import { render } from "./EscritorioAvisosCobradasAsitur.vue?vue&type=template&id=04e64520"
import script from "./EscritorioAvisosCobradasAsitur.vue?vue&type=script&lang=js"
export * from "./EscritorioAvisosCobradasAsitur.vue?vue&type=script&lang=js"

import "./EscritorioAvisosCobradasAsitur.vue?vue&type=style&index=0&id=04e64520&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__